import { useTranslation } from 'react-i18next'

import { Checkbox, Label } from '@mercai/clever'

import { LogisticPreferencesFormProps } from './logistic-preferences-form.type'

import styles from './logistic-preferences-form.module.css'
import {
  ProfileSelectedDeliveryDaysEnum,
  ProfileSelectedDeliveryPeriodsEnum,
} from '@/types'

export const LogisticPreferencesForm = ({
  onValuesChange,
  values,
}: LogisticPreferencesFormProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenProfileShow')

  const handleOnChangeValues = (
    key: string,
    value: string | number | boolean,
  ) => {
    if (key === 'selectedDeliveryPeriods' || key === 'selectedDeliveryDays') {
      let selectedValue: string[] = values?.[key] || []
      if (selectedValue.find((val) => val === value)) {
        selectedValue = selectedValue.filter((val) => val !== value)
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        selectedValue.push(value as any)
      }

      return onValuesChange({
        ...values,
        [key]: selectedValue,
      })
    }

    onValuesChange({ ...values, [key]: value })
  }

  return (
    <div className={styles.core}>
      <div className={styles['form-group']}>
        <Label>{t('logisticPreferencesFormTimeLabel')}</Label>
        <div>
          {Object.keys(ProfileSelectedDeliveryPeriodsEnum).map((key) => (
            <Checkbox
              key={key}
              value={
                !!values?.selectedDeliveryPeriods?.includes(
                  key as ProfileSelectedDeliveryPeriodsEnum,
                ) || false
              }
              onChange={() =>
                handleOnChangeValues('selectedDeliveryPeriods', key)
              }
            >
              {tEnums(`profile_selected_delivery_period_${key}`)}
            </Checkbox>
          ))}
        </div>
      </div>

      <div className={styles['form-group']}>
        <Label>{t('logisticPreferencesFormDaysLabel')}</Label>
        <div>
          {Object.keys(ProfileSelectedDeliveryDaysEnum).map((key) => (
            <Checkbox
              key={key}
              value={
                !!values?.selectedDeliveryDays?.includes(
                  key as ProfileSelectedDeliveryDaysEnum,
                ) || false
              }
              onChange={() => handleOnChangeValues('selectedDeliveryDays', key)}
            >
              {tEnums(`profile_selected_delivery_days_${key}`)}
            </Checkbox>
          ))}
        </div>
      </div>
    </div>
  )
}
